// extracted by mini-css-extract-plugin
export var alertIcon = "_ob-0";